import React from "react";
import { DataTable } from "./DataTable";
import { Button, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { useSupplierModel } from "../supplierModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { importPropsConfig } from "@/utils/importFile";
import { AuthButton } from "@/components/auth/AuthButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
export const DataBox = () => {
    const { selectedRowKeys, updateEditFormVal, importSupplier, exportSupplier, downloadTpl, loadData, transferSupplier } = useSupplierModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        let supplierEditKey = "13-1-2";
        let isFindNav = findNav(supplierEditKey);
        if (!isFindNav) {
            addNav(supplierEditKey, { id: selectedRowKeys[0], mode: "edit" });
        } else {
            globalPrompt("modal", {
                // title: "供应商跳转详情",
                title:Locale["Jump to the detail page"],
                type: "warning",
                // text: "您还有供应商详情未保存，是否跳转",
                text:Locale["The detail page has not been saved. Do you still want to jump?"],
                // okText: "跳转未保存页",
                okText: Locale["Jump to the unsaved page"],
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                // cancelText: "打开新页签",
                cancelText: Locale["Open a new page"],
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: selectedRowKeys[0], mode: "edit" });
                    updateEditFormVal(null);
                }
            })
        }
    }

    const action = <>
        <AuthButton
            // resCode="SupplierManagementAdd"
            resCode={ResourcesAuthBtn[mianCode]["SupplierManagementAdd"]}
            onClick={() => addNav("13-1-1", { id: "", mode: "add" })}
            // name="新增"
            name={Locale["Add"]}
        />
        <AuthButton
            // resCode="SupplierManagementEdit"
            resCode={ResourcesAuthBtn[mianCode]["SupplierManagementEdit"]}
            onClick={onEdit}
            // name="编辑"
            name={Locale["Edit"]}
        />
        <AuthButton
            // resCode="SupplierManagementImport"
            resCode={ResourcesAuthBtn[mianCode]["SupplierManagementImport"]}
        >
            <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/vrm-sa/base/supplier/import`, loadData)}>
                <Button className="mr-5" type="link" shape="round">{Locale["Import"]}</Button>
            </Upload>
        </AuthButton>

        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => addNav("13-1-1", { id: "", mode: "add" })}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onEdit}
        >编辑</Button> */}
        {/* <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/vrm-sa/base/supplier/import`, loadData)}>
            <Button className="mr-5" type="link" shape="round">导入</Button>
        </Upload>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { downloadTpl("id").then() }}
        >下载模板</Button> */}
    </>;

    return (
        <YhBox title={action}>
            <DataTable />
        </YhBox>
    )
}